import { Link } from 'react-router-dom'

import { Chat } from '@tribeplatform/gql-client/types'
import { Sidebar } from '@tribeplatform/react-ui-kit/Sidebar'

import { T } from '../../i18n/index.js'
import { isChatToMyself } from '../Chat/utils/chat.utils.js'
import { ChatImage } from '../components/ChatImage.js'

import { ChatActions } from './ChatActions.js'
import { CloseDetailsButton } from './CloseDetailsButton.js'
import { MemberAbout } from './MemberAbout.js'

interface Props {
  chat: Chat
}

export const ChatDetails = ({ chat }: Props) => {
  const peerParticipant = isChatToMyself(chat)
    ? chat.currentParticipant
    : chat.otherParticipant

  if (!peerParticipant) {
    return null
  }

  return (
    <Sidebar size="auto" withBorder={false} className="rounded-base">
      <Sidebar.Header className="p-8 sm:pb-8 relative">
        <div className="absolute top-4 left-3">
          <CloseDetailsButton />
        </div>
        <div className="flex flex-col items-center gap-3 w-full">
          <ChatImage
            type={chat.type}
            imageUrl={peerParticipant.avatarUrl}
            name={peerParticipant.name}
            size="6x"
          />
          <div className="text-lg font-semibold text-content">
            {peerParticipant?.name}
          </div>
          <Link to={`/member/${peerParticipant.memberId}`}>
            <T id="Generics.ViewProfile" defaultMessage="View profile" />
          </Link>
        </div>
      </Sidebar.Header>
      <Sidebar.Content className="p-0 border-t border-line-subdued">
        <div className="border-b border-line-subdued">
          <MemberAbout memberId={peerParticipant.memberId} />
        </div>
        <ChatActions peerParticipant={peerParticipant} chat={chat} />
      </Sidebar.Content>
    </Sidebar>
  )
}
